import { Empty, Table } from "antd";
import {
  overviewColumns,
  partColumns,
  productionComponentColumns,
  shiftColumns,
} from "../../constants/tableColumns/shiftSetting";
import get from "lodash/get";
import map from "lodash/map";

const TemplateListOverview = ({ dataSource, toggle, deleteConfig, filter, config, isStaff }) => {
  const PartsTable = ({ record }) => {
    return (
      <Table
        columns={partColumns(get(filter, "templateType"), config)}
        dataSource={get(record, "pc_parts")}
        pagination={false}
        size="small"
        bordered
        className="my-2"
       rowKey={(record) => get(record, "id") || crypto.randomUUID()}
      />
    );
  };

  const ProductionComponentsTable = ({ record }) => {
    if (get(record, "config.shift_production_components.length")) {
      return (
        <Table
          columns={productionComponentColumns(get(filter, "templateType"))}
          dataSource={map(
            get(record, "config.shift_production_components"),
            (item) => ({ ...item, key: get(item, "id") })
          )}
          bordered
          pagination={false}
          defaultExpandAllRows={true}
          size="small"
          className="my-2"
          expandable={{
            expandedRowRender: (record) => <PartsTable record={record} />,
            defaultExpandAllRows: false,
          }}
         rowKey={(record) => get(record, "id") || crypto.randomUUID()}
        />
      );
    } else {
      return (
        <div className="w-full">
            <Empty description="Config not present" />
        </div>
      );
    }
  };

  const ExpandedRowRender = ({ record, toggle, deleteConfig, filter, isStaff }) => {
    return (
      <Table
        columns={shiftColumns(record, toggle, deleteConfig, filter, isStaff)}
        dataSource={map(get(record, "shifts"), (item) => ({
          ...item,
          key: get(item, "id"),
        }))}
        rowClassName={(record) =>
          `${
            get(record, "config.shift_production_components.length") > 0
              ? "bg-[#F6FFED] text-[#52C41A]"
              : "bg-gray-200"
          }  font-semibold no-hover`
        }
        pagination={false}
        size="small"
        defaultExpandAllRows={true}
        expandable={{
          expandedRowRender: (record) => (
            <ProductionComponentsTable record={record} />
          ),
          defaultExpandAllRows: false,
        }}
        className="mt-2"
       rowKey={(record) => get(record, "id") || crypto.randomUUID()}
      />
    );
  };

  return (
    <div className="font-inter">
      <Table
        columns={overviewColumns()}
        dataSource={dataSource}
        pagination={false}
        size="small"
        defaultExpandAllRows={true}
        expandable={{
          expandedRowRender: (record) => (
            <ExpandedRowRender
              record={record}
              toggle={toggle}
              deleteConfig={deleteConfig}
              filter={filter}
              isStaff={isStaff}
            />
          ),
          defaultExpandAllRows: false,
        }}
        className="rounded-lg shadow-md overflow-hidden"
      rowKey={(record) => get(record, "id") || crypto.randomUUID()}
      />
    </div>
  );
};

export default TemplateListOverview;
